import { API_ENDPOINT } from "@/constants/appConstants";
import { VALIDATE_PROFILE_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { ErrorResponse } from "@/components/profile/types";

const validateProfile = async () => {
  try {
    const response = await fetch(
      API_ENDPOINT(window.location.host).middleware.validateProfile,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      const errorData = (await response.json()) as ErrorResponse;
      throw new Error(
        errorData.error.message.errorMessage || "Something went wrong",
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const getValidateProfile = (): UseQueryResult<any, Error> => {
  return useQuery({
    queryKey: [VALIDATE_PROFILE_QUERY_KEY],
    queryFn: () => validateProfile(),
  });
};
